export let normalImportanceMenuText = "Fms13d";
export default {normalImportanceMenuText};